import { combineEpics } from 'redux-observable';

import {
  getInitialInfo,
  getGameList,
  getUserGameList,
  getGame,
  requestGameKey,
  joinToBounty,
  leaveBounty,
  getUserPayments,
  getUserTodayActivity,
  getUserReferralsActivity,
  getUserTimedActivity,
  submitLink,
  submitAffiliateData,
  getMyQuestsPageData,
  getUserTickets,
  requestUpdateAvatarUrl,
  getBroadcast,
  submitRequirementData,
  checkRequirementData,
  getUserWallet,
  withdrawWallet,
  getWalletRollOutRecord,
  getWalletRollOutCsv,
  getWalletRollInRecord,
  getWalletRollInCsv,
  addRollInOrder,
  buyCDK,
  getCDKOrders,
  cancelCDKOrder,
  payCDKOrder,
  showCDKPay,
  getCDKOrderRecord,
  getCDKOrderRecordCsv,
  getCDKProducts,
  getTwitchDrop,
  getTwitchDropByIdentifier,
  getTwitchDrops,
  getAllSaleProductProperties,
  buySaleProduct,
  cancelSaleProductOrder,
  getSaleProductOrders,
  paySaleProductOrder,
  getUserSaleProducts,
  getRecomSaleProductOrders,
  getRecomSaleProductStatis,
  getRecomSaleProductRank,
  getSaleProductDetail,
} from './userEpic';

import {
  loginTwitch,
  loginWithTwitterOAuthCode,
  loginYoutube,
  loginWithSteamOAuthCode,
  loginTikTok,
  loginFacebook,
  updateUserInfo,
  updateInfoByUser,
  signInBefore,
  signIn,
  signUp,
  recover,
  recoverValidate,
  recoverChangePassword,
  disconnectTwitch,
  disconnectYoutube,
  disconnectTwitter,
  disconnectSteam,
  updateProfileInfo,
  validateUserHandshake,
  sendVerificationCode,
  validateVerificationCode,
  getCDK,
  signOut,
  refreshYoutubeAvgPlayCount,
  bindTwitchPlatform,
} from './authEpic';

import {
  uploadCSV,
  getGameLiveStreams,
  getGameBountiesData,
  getAUserList,
  getAUserListCsv,
  createAUser,
  createAUserBrand,
  getAUser,
  updateAUser,
  getAConfigList,
  createAConfig,
  getAConfig,
  updateAConfig,
  getAGameList,
  getAdminQuestListByGame,
  getAGame,
  createAGame,
  updateAGame,
  createAPlatform,
  getAllPlatforms,
  updateAFeatured,
  requestUploadImageUrl,
  getATrackedGames,
  getACampaignList,
  getACampaign,
  getACampaignQuestsReport,
  getAPaymentList,
  getAPaymentListCsv,
  getPaypalPayments,
  getAQuestList,
  // getInsightsData,
  // getInsightsOptions,
  createOffPlatformUser,
  getRollOutRecord,
  getRollOutCsv,
  approveRollOut,
  getRollOutAll,
  getRollOutRecordAdmin,
  getRollInCsv,
  getRollInRecordAdmin,
  showRollOutPay,
  getQuestLog,
  getQuestLogCsv,
  getProfileLog,
  getProfileLogCsv,
  getWalletLog,
  getWalletLogCsv,
  getCDKeyLog,
  getCDKeyLogCsv,
  getDailyTaskLog,
  getDailyTaskLogCsv,
  getChannelLog,
  getChannelLogCsv,
  getOtherLog,
  getOtherLogCsv,
  getLogSummary,
  createRegion,
  getRegions,
  getAllRegions,
  createRegions,
  updateRegion,
  updateRegions,
  getCDKOrderRecords,
  getCDKOrderRecordsCsv,
  getPermissions,
  updatePermissions,
  getAdmins,
  updateAdmins,
  showRollOutsPay,
  getReconciliationRollRecord,
  getReconciliationRollCsv,
  deductRoll,
  revokeDeduct,
  getUserVisitRecord,
  getRollInRecordLast,
  getCDKWarnRecords,
  getCDKBlacklistRecords,
  deleteCDKWarn,
  blackoutCDKWarn,
  deleteCDKBlacklist,
  getCDKDisputeRecords,
  getRollOutRecordAdminCsv,
  getCDKReviewRecords,
  getCDKRefundRecords,
  getCDKRefundRecordsCsv,
  getCDKDisputeRecordsCsv,
  getTip,
  getAdminTwitchDropListByGame,
  createSaleProduct,
  uploadSaleProductCDKeys,
  getSaleProducts,
    setSaleProductStatus,
    updateSaleProductSetting,
  updateSaleProduct,
  getASaleProductOrders,
  getSaleProductOrderStatis,
  getSaleProductOrderRank,
  getASaleProductOrdersCsv,
  approveUserWalletError,
  approveUserRollInError,
  getAnnouncementList,
  createAnnouncement,
  updateAnnouncement,
} from './adminEpic';

import {
  getCCGameList,
  uploadKeys,
  getGameKeys,
  deleteGameKeys,
  getBountyPredictions,
  getWhiteList,
  toggleUserInWhiteList,
  createUserAndWhiteListIt,
  findUsers,
  getGameActivity,
  distributeGameKeys,
  assignNewKeyPlatforms,
  getCCQuestList,
  createCCQuest,
  getCCQuest,
  copyCCQuest,
  updateCCQuest,
  getCCQuestActivity,
  getCCQuestSales,
  getCCQuestTimed,
  getCCQuestGeneral,
  getCCQuestGeneralCsv,
  getCCQuestAffiliate,
  postCCPreapproval,
  postCCRequirement,
  postCCRequirementMultiple,
  revokeCCRequirement,
  postCCAffiliateResolution,
  getCCQuestTiered,
  getCCQuestTieredMultipleDays,
  requestUploadCCImageUrl,
  getCCCampaignListByGame,
  getCCCampaign,
  createCCCampaign,
  updateCCCampaign,
  updateCCGamesPlatform,
  updateCCQuestsPlatform,
  addCCUserQuest,
  removeCCUserQuest,
  moveCCUserQuest,
  getCCActiveQuestsByGame,
  getLinksDashboard,
  uploadLinks,
  assignCustomLinks,
  assignMasterLinks,
  deleteLinks,
  postReputationRating,
  postApproveQuest,
  createCDKeyProduct,
  getCDKeyProducts,
  updateCDKeyProduct,
  uploadCDKeys,
  deleteCDKeys,
  getCDKRecords,
  createCCTwitchDrop,
  updateCCTwitchDrop,
  copyCCTwitchDrop,
  deleteTwitchDrop,
  getCCTwitchDrop,
} from './commandCenterEpic';

import {
  getQuest,
  joinQuest,
  joinQuestOffplatform,
  leaveQuest,
  requestGameKeyByQuest,
  getSFGame,
  getSFGameBySlug,
  postGamePayment,
  getQuestByIdentifier,
  getQuestBySlugGuest,
  requestReferralCodeByQuest,
  verifyYoutubeChannelStreamStatus,
  getStoreGames,
  getActiveAnnouncement,
} from './configEpic';

import {
  getOptimizedAllQuests,
  getAllGuestQuests,
  getOptimizedEndedQuests,
  getSearchLightGames,
  getSearchLightGameInfo,
  likeSearchLightGame,
  unlikeSearchLightGame,
} from './homeEpic';

import {
  getBUCampaignList,
  getBUCampaign,
  getBrandGame,
  getBrandQuest,
  getBrandStreamer,
  getBrandUserQuest,
  brandUserUploadImageUrl,
  postBrandGame,
  postBrandPreapproval,
  postBrandQuest,
  postBrandRequirement,
  putBrandGame,
  putBrandQuest,
} from './brandUserEpic';

const rootEpic = combineEpics(
  loginTwitch,
  loginWithTwitterOAuthCode,
  loginYoutube,
  loginWithSteamOAuthCode,
  loginTikTok,
  loginFacebook,
  disconnectTwitch,
  disconnectYoutube,
  disconnectTwitter,
  disconnectSteam,
  updateUserInfo,
  updateInfoByUser,
  uploadCSV,

  // <--------------- START NOIZ V2 EPICS --------------->
  getInitialInfo,
  getGameList,
  getUserGameList,
  getGame,
  requestGameKey,
  joinToBounty,
  leaveBounty,
  requestGameKeyByQuest,
  getGameLiveStreams,
  getGameBountiesData,
  getCCGameList,
  uploadKeys,
  getGameKeys,
  deleteGameKeys,
  getBountyPredictions,
  getWhiteList,
  toggleUserInWhiteList,
  createUserAndWhiteListIt,
  findUsers,
  getGameActivity,
  distributeGameKeys,
  assignNewKeyPlatforms,
  // <--------------- END NOIZ V2 EPICS --------------->

  // <--------------- START NOIZ V3 EPICS --------------->
  signInBefore,
  signIn,
  signUp,
  recover,
  recoverValidate,
  recoverChangePassword,
  getCCQuestList,
  getCCQuest,
  copyCCQuest,
  createCCQuest,
  updateCCQuest,
  getAUserList,
  getAUserListCsv,
  createAUser,
  createAUserBrand,
  getAUser,
  updateAUser,
  getAPaymentList,
  getAPaymentListCsv,
  getPaypalPayments,
  getAQuestList,
  getAConfigList,
  createAConfig,
  getAConfig,
  updateAConfig,
  getQuest,
  joinQuest,
  joinQuestOffplatform,
  leaveQuest,
  submitLink,
  submitAffiliateData,
  submitRequirementData,
  checkRequirementData,
  requestUpdateAvatarUrl,
  getSFGame,
  getSFGameBySlug,
  postGamePayment,
  getAdminQuestListByGame,
  getUserPayments,
  updateProfileInfo,
  validateUserHandshake,
  sendVerificationCode,
  validateVerificationCode,
  refreshYoutubeAvgPlayCount,
  getCCCampaignListByGame,
  getCCCampaign,
  createCCCampaign,
  updateCCCampaign,
  updateCCGamesPlatform,
  updateCCQuestsPlatform,

  getUserTodayActivity,
  getUserReferralsActivity,
  getUserTimedActivity,
  getMyQuestsPageData,
  getUserTickets,
  getUserWallet,
  withdrawWallet,
  getWalletRollOutRecord,
  getWalletRollOutCsv,
  getWalletRollInRecord,
  getWalletRollInCsv,
  addRollInOrder,
  getRollOutRecord,
  getRollOutCsv,
  approveRollOut,
  getRollOutAll,
  showRollOutPay,
  getCCQuestActivity,
  getCCQuestSales,
  getCCQuestTimed,
  getCCQuestGeneral,
  getCCQuestGeneralCsv,
  getCCQuestAffiliate,
  postCCPreapproval,
  postCCRequirement,
  postCCRequirementMultiple,
  revokeCCRequirement,
  postCCAffiliateResolution,
  getCCQuestTiered,
  getCCQuestTieredMultipleDays,
  getQuestByIdentifier,
  getQuestBySlugGuest,
  requestReferralCodeByQuest,
  getAGameList,
  getAGame,
  createAGame,
  updateAGame,
  createAPlatform,
  getAllPlatforms,
  updateAFeatured,
  verifyYoutubeChannelStreamStatus,
  requestUploadImageUrl,
  // <--------------- END NOIZ V3 EPICS --------------->

  // <--------------- START NOIZ V4 EPICS --------------->
  getOptimizedAllQuests,
  getAllGuestQuests,
  getOptimizedEndedQuests,
  getSearchLightGames,
  getSearchLightGameInfo,
  likeSearchLightGame,
  unlikeSearchLightGame,
  requestUploadCCImageUrl,
  getATrackedGames,
  getBUCampaignList,
  getBUCampaign,
  getACampaignList,
  getACampaign,
  getACampaignQuestsReport,
  getBroadcast,
  getStoreGames,
  addCCUserQuest,
  removeCCUserQuest,
  moveCCUserQuest,
  getCCActiveQuestsByGame,
  getLinksDashboard,
  uploadLinks,
  assignCustomLinks,
  assignMasterLinks,
  deleteLinks,
  postReputationRating,
  createOffPlatformUser,
  getBrandGame,
  getBrandQuest,
  getBrandStreamer,
  getBrandUserQuest,
  brandUserUploadImageUrl,
  postBrandGame,
  postBrandPreapproval,
  postBrandQuest,
  postBrandRequirement,
  putBrandGame,
  putBrandQuest,
  // <--------------- END NOIZ V4 EPICS --------------->

  // <--------------- START NOIZ V5 EPICS --------------->
  postApproveQuest,
  getRollOutRecordAdmin,
  getRollInCsv,
  getRollInRecordAdmin,
  getQuestLog,
  getQuestLogCsv,
  getProfileLog,
  getProfileLogCsv,
  getWalletLog,
  getWalletLogCsv,
  getCDKeyLog,
  getCDKeyLogCsv,
  getDailyTaskLog,
  getDailyTaskLogCsv,
  getChannelLog,
  getChannelLogCsv,
  getOtherLog,
  getOtherLogCsv,
  getLogSummary,
  createRegion,
  getRegions,
  getAllRegions,
  createRegions,
  updateRegion,
  updateRegions,
  createCDKeyProduct,
  getCDKeyProducts,
  updateCDKeyProduct,
  uploadCDKeys,
  deleteCDKeys,
  buyCDK,
  getCDKOrders,
  cancelCDKOrder,
  payCDKOrder,
  getCDK,
  showCDKPay,
  getCDKOrderRecord,
  getCDKOrderRecordCsv,
  getCDKOrderRecords,
  getCDKOrderRecordsCsv,
  getCDKRecords,
  getCDKProducts,
  getPermissions,
  updatePermissions,
  getAdmins,
  updateAdmins,
  showRollOutsPay,
  getReconciliationRollRecord,
  getReconciliationRollCsv,
  deductRoll,
  revokeDeduct,
  getUserVisitRecord,
  getRollInRecordLast,
  getCDKWarnRecords,
  getCDKBlacklistRecords,
  deleteCDKWarn,
  blackoutCDKWarn,
  deleteCDKBlacklist,
  getCDKDisputeRecords,
  getRollOutRecordAdminCsv,
  getCDKReviewRecords,
  getCDKRefundRecords,
  getCDKRefundRecordsCsv,
  getCDKDisputeRecordsCsv,
  getTip,
  signOut,
    createCCTwitchDrop,
    updateCCTwitchDrop,
    getAdminTwitchDropListByGame,
    copyCCTwitchDrop,
    deleteTwitchDrop,
    getCCTwitchDrop,
    getTwitchDrop,
    getTwitchDropByIdentifier,
    getTwitchDrops,
    bindTwitchPlatform,
    createSaleProduct,
    getAllSaleProductProperties,
    uploadSaleProductCDKeys,
    getSaleProducts,
    setSaleProductStatus,
    updateSaleProductSetting,
    updateSaleProduct,
    buySaleProduct,
    cancelSaleProductOrder,
    getSaleProductOrders,
    getASaleProductOrders,
    paySaleProductOrder,
    getUserSaleProducts,
    getRecomSaleProductOrders,
    getRecomSaleProductStatis,
    getRecomSaleProductRank,
    getSaleProductOrderStatis,
    getSaleProductOrderRank,
    getSaleProductDetail,
    getASaleProductOrdersCsv,
    approveUserWalletError,
    approveUserRollInError,
  // <--------------- END NOIZ V5 EPICS --------------->

  // <--------------- ANNOUNCEMENTS --------------->
  getActiveAnnouncement,
  getAnnouncementList,
  createAnnouncement,
  updateAnnouncement,
);

export default rootEpic;
